import styled from 'styled-components';
import StepsBar from './StepsBar';

export default styled(StepsBar)`
  display: flex;
  margin-bottom: 1.6rem;

  .steps-bar {
    &__list {
      list-style: none;
      margin-left: 0;
      padding: 0;
      display: flex;
      width: 100% !important;
    }

    &__item {
      height: 2px;
      background-color: var(--grey300);
      margin-right: 2px;
      width: 100%;

      &--active {
        background-color: var(--primary500);
      }

      &--red {
        background-color: var(--red-cherry-text);
      }

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
`;
